export const checkCondition = (conditions, userData) => {
    if (!userData) return false
    if (conditions.isStaff !== userData?.is_staff) return false
    return userData?.role === conditions.role || conditions.role === undefined
}
